// extracted by mini-css-extract-plugin
export default {"component":"toast_component__Z+IIU","mobile":"toast_mobile__Tg1um","responsive":"toast_responsive__QRTJN","withScroll":"toast_withScroll__1rCnV"};